export default __webpack_public_path__ + "static/media/trip_origin_icon.05d6f2ae.svg";